import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_13.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/voices');
  const shareText = encodeURIComponent('Launches HR Voices!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Launches HR Voices — Outstanding Workplaces</title>
        <meta property="og:title" content="Launches HR Voices — Outstanding Workplaces" />
        <meta property="og:description" content=" Outstanding Workplaces Launches HR Voices Event Series" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778046026/i_13_udz1pi.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/voices" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Launches HR Voices — Outstanding Workplaces" />
        <meta name="twitter:description" content=" Outstanding Workplaces Launches HR Voices Event Series" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778046026/i_13_udz1pi.jpg" />
      </Helmet>

     <div className="sight_13_page_wrapper">
        <div className="sight_13_content_container">

          <div className="sight_13_section_one">

            {/* TITLE */}
            <h1 className="sight_13_page_title">
              Outstanding Workplaces Launches HR Voices Event Series
            </h1>

            {/* ROW */}
            <div className="sight_13_row">

              {/* LEFT */}
              <div className="sight_13_left">
                <div className="sight_13_image_wrapper">
                  <img src="/assets/i_13.jpg" alt="Team meeting discussion" className="sight_13_blog_image" />
                </div>



                {/* SHARE SECTION */}
                <div className="sight_13_share_section">
                  <span className="sight_13_share_text">Share :</span>
                  <div className="sight_13_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_13_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_13_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_13_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_13_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

             
                <p className="sight_13_intro_paragraph">
                  In an era where the world of work is evolving faster than ever, meaningful conversations around people, culture, and leadership have never been more critical. Recognizing this need, Outstanding Workplaces proudly announces the launch of its flagship event series — HR Voices.
                </p>
              </div>

              {/* RIGHT */}
              <div className="sight_13_right">
                <div className="sight_13_ad_card">
                  <img src="/assets/bc_1.png" className="sight_13_ad_bg" />
                  <div className="sight_13_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_13_ad_badge" />

                  <div className="sight_13_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>

                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>

                    <button
                      className="sight_13_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* ===== SECTION TWO ===== */}
          <div className="sight_13_section">

            <div className="sight_13_topics">

              <div className="sight_13_topic_item">
                <h2 className="sight_13_topic_heading">
                  A Platform for Real Conversations
                </h2>
                <ul className="sight_13_topic_list">
                  <li>
                    HR Voices is more than just an event series — it is a dynamic platform designed to bring together HR leaders, industry experts, and change-makers to engage in authentic, forward-thinking conversations. The series aims to explore the most pressing challenges and emerging trends shaping the future of work.
                  </li>
                  <li>
                    From talent transformation and leadership evolution to workplace culture and employee experience, HR Voices will spotlight the ideas that matter most.
                  </li>
                </ul>
              </div>

              <div className="sight_13_topic_item">
                <h2 className="sight_13_topic_heading">
                  Why HR Voices?
                </h2>
                <ul className="sight_13_topic_list">
                  <li>
                    The workplace is undergoing a significant transformation driven by technology, shifting employee expectations, and global disruptions. HR leaders today are not just enablers but strategic drivers of business success.
                  </li>
                </ul>
              </div>

              <div className="sight_13_topic_item">
                <h2 className="sight_13_topic_heading">
                  HR Voices is built on the belief that:
                </h2>
                <ul className="sight_13_topic_list">
                  <li>
                    Highlight internal leadership grooming practices, mentoring models, and growth opportunities for emerging leaders.
                  </li>
                </ul>
              </div>

              <div className="sight_13_topic_item">
                <h2 className="sight_13_topic_heading">
                  People-First Practices That Power Business Excellence
                </h2>
                <ul className="sight_13_topic_list">
                  <li>
                    Conversations drive change
                  </li>
                    <li>
                    Shared experiences inspire innovation
                  </li>
                    <li>
                    Collaboration fuels growth
                  </li>
                </ul>
                <p className="sight_13_description">
                 This series provides a space where ideas are exchanged, perspectives are challenged, and solutions are co-created.
                </p>
              </div>

<div className="sight_13_topic_item">

  <h2 className="sight_13_topic_heading">
    What to Expect
  </h2>

  <p className="sight_13_intro">
    Each edition of HR Voices will feature:
  </p>

  <ul className="sight_13_topic_list">
    <li>Insightful panel discussions with industry leaders</li>
    <li>Interactive sessions and knowledge-sharing forums</li>
    <li>Real-world case studies and success stories</li>
    <li>Networking opportunities with HR professionals and business leaders</li>
  </ul>

  <p className="sight_13_description">
    Participants can expect actionable insights, meaningful dialogue, and a chance to be part of a growing community shaping the future of HR.
  </p>

</div>

              <div className="sight_13_topic_item">
                <h2 className="sight_13_topic_heading">
                  Building the Future of Work Together
                </h2>
                <ul className="sight_13_topic_list">
                  <li>
                    With HR Voices, Outstanding Workplaces continues its mission of empowering organizations and inspiring people. By creating a platform for continuous learning and collaboration, the initiative aims to strengthen the HR ecosystem and support organizations in building resilient, inclusive, and high-performing workplaces.
                  </li>
                </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;
